/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactShare extends models.AgentFieldsBase {
    getFixupPrototypeFunction() { return ArtifactShare.fixupPrototype; }

    static newInstance(model: Partial<ArtifactShare>): ArtifactShare {
        let obj = Object.assign(new ArtifactShare(), model);
        ArtifactShare.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactShare>): ArtifactShare {
        if (!model) return null;
        return ArtifactShare.newInstance(<ArtifactShare> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactShare) {
        if (!obj) return;

        models.ArtifactShare.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactShare): boolean {
        if (models.AgentFieldsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ArtifactShare.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * ID of the shared artifact
     */
    artifact_id: string;

    /**
     * Name of the user who created the share.
     */
    created_by: string;

    /**
     * How the artifact was shared
     */
    share_type: models.ArtifactShareType;

    /**
     * ID of the in-tenant user this artifact was shared with, if share_type is 'user'
     */
    target_user_id: string;

    /**
     * External email address this artifact was shared with, if share_type is 'email'
     */
    target_email: string;

    /**
     * Whether this share has been revoked
     */
    revoked: boolean = false;

}
